import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconMiusOutlined: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.25C6.61406 2.25 2.25 6.61406 2.25 12C2.25 17.3859 6.61406 21.75 12 21.75C17.3859 21.75 21.75 17.3859 21.75 12C21.75 6.61406 17.3859 2.25 12 2.25ZM12 3.5625C14.2547 3.5625 16.3734 4.43906 17.9672 6.03281C19.5609 7.62656 20.4375 9.74531 20.4375 12C20.4375 14.2547 19.5609 16.3734 17.9672 17.9672C16.3734 19.5609 14.2547 20.4375 12 20.4375C9.74531 20.4375 7.62656 19.5609 6.03281 17.9672C4.43906 16.3734 3.5625 14.2547 3.5625 12C3.5625 9.74531 4.43906 7.62656 6.03281 6.03281C7.62656 4.43906 9.74531 3.5625 12 3.5625ZM7.00781 12C7.00781 11.5312 7.34531 11.25 7.75781 11.25H16.2422C16.6547 11.25 16.9922 11.5875 16.9922 12C16.9922 12.4125 16.6547 12.75 16.2422 12.75H7.75781C7.35938 12.75 7.00781 12.4688 7.00781 12Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconMiusOutlined;
